import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectNewsroomAssets } from '@client/content/redux/newsroom/redux';
import { NewsroomAssetsType } from 'b2b-common/core/content/Newsroom.types';


export function useNewsroomAssetsData(): RemoteRecord<NewsroomAssetsType> {
  return useSelector(selectNewsroomAssets);
}
